<div id="addPresentationModal">
  <div class="tw-flex tw-justify-end tw-mr-[5px]">
    <button
      type="button"
      mat-icon-button
      class="close"
      (click)="dismiss()"
      aria-label="Close this modal"
    >
      <streamline-icon name="close" width="12" height="12"></streamline-icon>
    </button>
  </div>
  <h4 class="tw-text-center tw-mb-2.5">Select Presentations</h4>
  <p class="tw-text-left tw-text-gray-700 tw-px-5 tw-mb-0">
    Choose the presentations that you would like to play in this playlist.
  </p>
  <mat-dialog-content
    class="presentation-multi-selector__content"
    rvSpinner="presentation-list-loader"
    [rvShowSpinner]="isLoading"
  >
    <search-filter
      [filterConfig]="filterConfig"
      [search]="search"
      [doSearch]="presentations.doSearch"
    ></search-filter>
    @if (foldersSupported) {
      <div
        class="tw-flex tw-flex-col tw-gap-2.5 tw-px-4 tw-border-solid tw-border-0 tw-border-t tw-border-gray-200 tw-mt-2.5"
      >
        <folder-path
          [folderTree]="folderBrowser.folderTree()"
          [folderId]="search.folderId"
          (folderClicked)="onFolderClicked($event)"
          rootName="Presentations"
        ></folder-path>
      </div>
    }
    <div class="presentation-multi-selector__list-host">
      <div
        class="scrollable-list horizontal-scroll sticky-thead"
        scrollingList
        (scrollEndEvent)="presentations.load()"
      >
        <table id="presentationListTable" class="table table--hover">
          <thead class="table-header">
            <tr class="table-header__row">
              <th class="table-header__cell">
                <mat-checkbox
                  [ngModel]="areAllPresentationsSelected()"
                  (change)="selectAll($event.checked)"
                ></mat-checkbox>
              </th>
              <th
                id="tableHeaderName"
                (click)="presentations.sortBy('name')"
                class="table-header__cell u_clickable"
              >
                Name
                <!-- ngIf: search.sortBy == 'name' -->
                @if (search.sortBy === 'name') {
                  <i
                    [attr.aria-label]="
                      search.reverse ? 'Descending order' : 'Ascending order'
                    "
                    class="fa"
                    [ngClass]="
                      { false: 'fa-caret-up', true: 'fa-caret-down' }[
                        search.reverse
                      ]
                    "
                  ></i>
                }
                <!-- end ngIf: search.sortBy == 'name' -->
              </th>
              <th id="tableHeaderStatus" class="table-header__cell">Status</th>
            </tr>
          </thead>
          <tbody class="table-body">
            @for (item of items; track item) {
              @if (isFolderItem(item)) {
                <tr class="table-body__row" (click)="onFolderClicked(item.id)">
                  <td class="table-body__cell">
                    <mat-icon
                      svgIcon="folder"
                      class="tw-text-gray-500 tw-ml-2 tw-mt-[5px]"
                    />
                  </td>
                  <td class="table-body__cell">
                    <div class="flex-row">
                      <a
                        role="button"
                        tabindex="0"
                        (click)="
                          $event.stopPropagation(); onFolderClicked(item.id)
                        "
                        (keydown.enter)="onFolderClicked(item.id)"
                        (keydown.space)="
                          $event.preventDefault(); onFolderClicked(item.id)
                        "
                        class="u_ellipsis-lg !tw-text-black tw-font-medium"
                        [attr.aria-label]="'Open folder ' + item.name"
                      >
                        {{ item.name }}
                      </a>
                    </div>
                  </td>
                  <td class="table-body__cell text-right"></td>
                </tr>
              } @else {
                <tr
                  class="table-body__row u_clickable"
                  (click)="selectPresentation(item)"
                >
                  <td class="table-body__cell">
                    <mat-checkbox
                      class="tw-ml-[2.5px]"
                      [ngModel]="item.selected"
                      (change)="
                        $event.stopPropagation(); selectPresentation(item)
                      "
                    ></mat-checkbox>
                  </td>
                  <td class="table-body__cell">
                    <div class="flex-row">
                      <a
                        id="presentationName"
                        class="u_ellipsis-lg !tw-text-black tw-font-medium"
                        >{{ item.name }}</a
                      >
                    </div>
                  </td>
                  <td class="table-body__cell">
                    <status-badge [status]="item.revisionStatusName" />
                  </td>
                </tr>
              }
            }
            <!-- If no presentation available -->
            <tr
              class="table-body__row"
              [shown]="
                !presentations.loadingItems &&
                items.length === 0 &&
                !search.query
              "
            >
              <td colspan="3" class="text-center">
                Add a presentation to start communicating better with your
                audience!
              </td>
            </tr>
            <!-- If no search results -->
            <tr
              class="table-body__row"
              [shown]="items.length === 0 && search.query"
            >
              <td colspan="3" class="text-center">
                Your search didn't return any results.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="tw-mt-[5px] tw-gap-2.5 tw-pt-5">
    <button
      rv-button
      variant="secondary"
      class="tw-w-full md:!tw-w-fit"
      id="cancel"
      type="button"
      (click)="dismiss()"
    >
      Cancel
    </button>
    <button
      rv-button
      id="selectPresentations"
      type="submit"
      class="tw-w-full md:!tw-w-fit"
      (click)="add()"
      [disabled]="!presentations?.getSelected().length"
    >
      Add Selected
    </button>
  </mat-dialog-actions>
</div>
